import { customElement } from "lit/decorators.js";
import { PrimariaContentSwitcher } from "./primaria-content-switcher/primaria-content-switcher";
import { PrimariaNavItem } from "./primaria-nav-item/primaria-nav-item";
import { PrimariaNavTreeMenu } from "./primaria-nav-tree-menu/primaria-nav-tree-menu";
import { PrimariaRichTextEditor } from "./primaria-text-editor/primaria-rich-text-editor";
import { PrimariaCharacterLimitBadge } from "./primaria-character-limit-badge/primaria-character-limit-badge";
import { PrimariaRegion } from "./primaria-region";

export const useSharedUI = () => {
  customElement("primaria-content-switcher")(PrimariaContentSwitcher);
  customElement("primaria-nav-item")(PrimariaNavItem);
  customElement("primaria-rich-text-editor")(PrimariaRichTextEditor);
  customElement("primaria-nav-tree-menu")(PrimariaNavTreeMenu);
  customElement("primaria-character-limit-badge")(PrimariaCharacterLimitBadge);
   customElement("primaria-region")(PrimariaRegion);
};
